import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import modalSlice from './slice/modal.slice'
import userSlice from './slice/user.slice'
import loadingSlice from './slice/loadingSlice';


export default configureStore({
  reducer: {
    modal: modalSlice,
    users: userSlice,
    loading:loadingSlice
  },
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false
    })
  ],
  devTools: false
})
